import './PreventiveContent.scss';

import { useEffect } from "react";
import { useMemo } from "react";

import { useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useApplyFilters } from "../../../hooks/useApplyFilters";

import { fetchPreventive } from "../../../slices/preventiveSlice";

import { Table } from "../../../common-components/Table/Table";
import { List } from "../../../common-components/List/List";
import { Pagination } from "../../../common-components/Pagination/Pagination";

import PreventiveTools from "../PreventiveTools/PreventiveTools";

const PreventiveContent = () => {
    const dispatch = useDispatch();
    const componentId = "preventive";
    const navigate = useNavigate();
    const token = useSelector((state) => state.auth.token);
    const columnsFromStore = useSelector((state) => state.preventive.columns);
    const dataFromStore = useSelector((state) => state.preventive.data);
    const meta = useSelector((state) => state.preventive.meta);
    const { params } = useApplyFilters({componentId});

    useEffect(() => {
        dispatch(fetchPreventive({ token, params }));
    }, [dispatch, token, params]);

    const columns = useMemo(() => {
        if (!columnsFromStore) return [];
        return columnsFromStore.map(col => ({
            key: col.key,
            header: col.alias || col.name || col.key
        }));
    }, [columnsFromStore]);

    const data = useMemo(() => {
        if (!Array.isArray(dataFromStore)) return [];
        return dataFromStore.map((item) => {
            const attributes = item?.attributes || {};
            return {
                id: item.id,
                ...attributes
            };
        });
    }, [dataFromStore]);

    return (
        <div className={"preventive-content"}>
            <div className={"preventive-content_container"}>
                <div className={"preventive-content_tools"}>
                    <PreventiveTools/>
                </div>
                <div className={"preventive-content_table"}>
                    <Table data={data} requireColumns={columns} basePath={"/DetailsPreventive"} onRowClick={(row) => navigate(`/DetailsPreventive/${row.id}`)}/>
                </div>
                <div className={"preventive-content_list"}>
                    <List data={data} clientColumns={columns} onClick={(row) => navigate(`/DetailsPreventive/${row.id}`)}/>
                </div>
                <div className={"preventive-content_pagination"}>
                    <Pagination meta={meta}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveContent;